import validate from "/home/circleci/project/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45reflesh_45session_45global from "/home/circleci/project/middleware/01.refleshSession.global.ts";
import _02_45authenticated_45global from "/home/circleci/project/middleware/02.authenticated.global.ts";
import _03_45check_45permission_45global from "/home/circleci/project/middleware/03.checkPermission.global.ts";
import _04_45banner_45global from "/home/circleci/project/middleware/04.banner.global.ts";
import manifest_45route_45rule from "/home/circleci/project/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45reflesh_45session_45global,
  _02_45authenticated_45global,
  _03_45check_45permission_45global,
  _04_45banner_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "after-company-info-register": () => import("/home/circleci/project/middleware/afterCompanyInfoRegister.ts"),
  "assist-mode": () => import("/home/circleci/project/middleware/assistMode.ts"),
  "service-admin": () => import("/home/circleci/project/middleware/serviceAdmin.ts"),
  unauthenticated: () => import("/home/circleci/project/middleware/unauthenticated.ts")
}